export default __webpack_public_path__ + "static/media/invoice-received.d4dc62d1.svg";